import apiClient, { getUserInfo, setUserInfo } from '@shared/api/client';
import { ENDPOINTS } from '@shared/api/endpoints';

export async function getVoucherList() {
    const response = await apiClient.post(ENDPOINTS.REDEEM.m16_VOUCHER_LIST, {});
    return response;
}

export async function getVoucherMascotList(item_id) {
    const response = await apiClient.post(ENDPOINTS.REDEEM.m17_VOUCHER_MASCOT_LIST, {
        item_id: item_id
    });
    return response;
}

export async function exchangeVoucher(user_voucher_id, reward_id) {
    const response = await apiClient.post(ENDPOINTS.REDEEM.m18_EXCHANGE, {
        user_voucher_id: Number(user_voucher_id),
        reward_id: Number(reward_id)
    });
    // const response = {
    //     success: true,
    //     message: "兌換成功",
    //     encouragement: "恭喜獲得 35 週年專屬紀念！"
    // }
    return response;
}

export async function getMascotDescribe(reward_id) {
    const response = await apiClient.post(ENDPOINTS.POINT_EX.ITEMS_LIST, {
        reward_id: Number(reward_id)
    });
    return response;
}

export async function exchangeMascot(reward_id) {
    const response = await apiClient.post(ENDPOINTS.REDEEM.MASCOT_EXCHANGE, {
        reward_id: reward_id
    });
    // const response = {
    //     success: true,
    //     message: "兌換成功",
    //     encouragement: "恭喜獲得 35 週年專屬紀念！"
    // }
    return response;
}